var __jsx = React.createElement;
/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { getOrderedLocations } from '../GoogleMapsHappyHealthyPets/Helper';
import styled from 'styled-components';
import styles from '../GoogleMapsHappyHealthyPets/GoogleMapsHappyHealthyPets.style';
import SearchLocation from './SearchLocation';
import Filters from './Filters';
import MapListToggle from './MapListToggle';
import SideBar from './SideBar';
import MapView from './MapView';
import MapHandler from './MapHandler';
import MapStateProvider from './MapStateProvider';
var GoogleMapsBlock = styled.section.withConfig({
  componentId: "sc-1rdio2c-0"
})(["", ";"], styles);
var GoogleMaps = function GoogleMaps(props) {
  var _props$happyHealthyPe = props.happyHealthyPetsData.businessLineLocations,
    businessLineLocations = _props$happyHealthyPe === void 0 ? [] : _props$happyHealthyPe;
  var _useState = useState(false),
    toggleMap = _useState[0],
    setToggleMap = _useState[1];
  var _useState2 = useState(null),
    selectedPlace = _useState2[0],
    setSelectedPlace = _useState2[1];
  var _useState3 = useState(null),
    deviceLocation = _useState3[0],
    setDeviceLocation = _useState3[1];
  var handlePlaceSelect = function handlePlaceSelect(place) {
    setSelectedPlace(place);
  };
  var handleDeviceLocation = function handleDeviceLocation(lat, lng) {
    setDeviceLocation({
      lat: lat,
      lng: lng
    });
  };
  return __jsx(MapStateProvider, {
    initialData: {
      businessLineLocations: businessLineLocations
    }
  }, __jsx(GoogleMapsBlock, {
    className: "nva-maps-hhpets"
  }, __jsx("div", {
    className: "nva-maps-hhpets__container map-container"
  }, __jsx(SearchLocation, {
    onPlaceSelect: handlePlaceSelect,
    onDeviceLocation: handleDeviceLocation
  }), __jsx(Filters, {
    businessLineLocations: businessLineLocations
  }), __jsx(MapListToggle, {
    toggleMap: toggleMap,
    setToggleMap: setToggleMap
  }), __jsx(SideBar, {
    toggleMap: toggleMap,
    setToggleMap: setToggleMap,
    getOrderedLocations: getOrderedLocations
  }), __jsx(MapView, {
    toggleMap: toggleMap,
    setToggleMap: setToggleMap
  }), __jsx(MapHandler, {
    selectedPlace: selectedPlace,
    deviceLocation: deviceLocation
  }))));
};
export default /*#__PURE__*/React.memo(GoogleMaps);